<template>
  <div class="device-con">
    <div class="tabs">
      <div
        :class="['item', { active: activeTab === v.value }]"
        v-for="v in activeArr"
        :key="v.value"
        @click="activeTab = v.value">{{ v.label }}
      </div>
    </div>
    <div class="search">
      <el-row :gutter="3" v-if="shopType">
        <el-col :span="1.5">
          <div class="label">选择门店</div>
        </el-col>
        <el-col :span="3">
          <custom-select
            v-model="searchForm.merchantIdList"
            :list="shopList"
            :pageLoading="shopPageInfo.loading"
            @loadmore="queryShopList"/>
        </el-col>
      </el-row>
      <el-form inline class="inline-form" :model="searchForm" label-width="80px" label-position="left">
        <el-form-item label="设备编号">
          <el-input
            v-model="searchForm.transToolNum"
            placeholder="请输入设备编号"
            style="width: 310px;"
            size="small"/>
        </el-form-item>
        <el-form-item label="设备名称" style="margin-left: 30px;">
          <el-input
            v-model="searchForm.transToolCustomerName"
            placeholder="请输入设备名称"
            style="width: 310px;"
            size="small"/>
        </el-form-item>
        <el-button type="primary" @click="search" class="btn-base bs-btn">查询</el-button>
      </el-form>
    </div>
    <div class="table-list">
      <div class="table-container">
        <el-table :data="tableData" style="width: 100%;" border v-loading="loadingTable">
          <el-table-column prop="transToolNum" :label="activeCode ? '码牌编号' : '设备编号'" align="center"/>
          <el-table-column prop="transToolCustomerName" :label="activeCode ? '码牌名称' : '设备名称'" align="center"/>
          <el-table-column prop="merchantName" label="所属门店" align="center"/>
          <el-table-column prop="transToolName" label="设备类型" align="center"/>
          <el-table-column prop="bindTime" :label="activeCode ? '绑定时间' : '激活时间'" align="center"/>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{row}">
              <div v-if="activeTab === 3">{{ row.status === 0 ? "未激活" : "已激活" }}</div>
              <div v-if="activeTab === 4">{{ row.status === 2 ? "已绑定" : "已激活" }}</div>
              <div v-if="activeCode">{{ row.status === 0 ? "关闭" : "启用" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{row}">
              <span v-if="activeTab === 1" class="table-btn" @click="viewCodeDetail(row)">查看</span>
              <span class="table-btn last-btn" @click="modifyDetail(row)">修改</span>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"/>
        </el-col>
      </div>
    </div>
    <!-- 查看弹窗 -->
    <el-dialog :visible.sync="coedDialog" width="30%">
      <div class="code" v-loading="codeLoading">
        <div class="money text" v-if="code.fixedAmount">
          <span>￥</span>{{ code.fixedAmount / 100 }}
        </div>
        <div class="name text">{{ code.fixedQrcodeDescription }}</div>
        <div class="code-img">
          <vue-qr
            :logo-src="config.logoSrc"
            :margin="0"
            :auto-color="true"
            :text="config.value"
            :size="200"
            :dot-scale="1"
            ref="payCode"/>
        </div>
        <div class="icon-box">
          <img v-for="(v, i) in iconArr" :key="i" :src="v">
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bs-btn" @click="coedDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改弹窗 -->
    <el-dialog
      title="设备管理"
      :visible.sync="modifyDeviceDialog"
      width="30%"
      class="modify-device-dialog"
      :before-close="cancelDevice">
      <el-form
        v-if="activeTab === 1 || activeAndNotZfbBox"
        :model="modifyForm"
        :rules="modifyFormRules"
        ref="modifyForm"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item label="码牌名称" prop="transToolCustomerName">
          <el-input v-model="modifyForm.transToolCustomerName" placeholder="请输入码牌名称" clearable/>
        </el-form-item>
      </el-form>
      <el-form
        v-if="!activeCode || activeAndIsZfbBox"
        :model="modifyNameForm"
        :rules="modifyNameFormRules"
        ref="modifyNameForm"
        label-width="120px"
        class="demo-ruleForm">
        <el-form-item label="设备名称" prop="transToolCustomerName">
          <el-input v-model="modifyNameForm.transToolCustomerName" placeholder="请输入设备名称"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="bs-btn2" @click="cancelDevice">取 消</el-button>
        <el-button
          class="bs-btn"
          type="primary"
          @click="submitInfo"
          v-if="activeTab === 1 || activeAndNotZfbBox">确 定</el-button>
        <el-button
          class="bs-btn"
          type="primary"
          @click="submitInfoName"
          v-if="!activeCode || activeAndIsZfbBox">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import CustomSelect from "@/components/CustomSelect/index.vue";
import { queryShopList } from "@/api/merchant-info";
import { listTransToolInfo, updateTransToolInfo, getQrcodePage } from "@/api/device-manage";

export default {
  name: 'device-manage',
  components: {
    CustomSelect,
    VueQr,
  },
  data() {
    return {
      activeTab: 1,
      activeArr: [
        { label: '收款码', value: 1 },
        { label: '云喇叭', value: 2 },
        { label: '收款设备', value: 3 },
        { label: 'PC插件', value: 4 },
      ],
      shopList: [{ merchantId: "@", merchantName: "全部门店", checked: true }],
      shopPageInfo: {
        pageNo: 1,
        loading: false,
        finished: false,
        pageSize: 30,
      },
      searchForm: {
        merchantIdList: [],
        transToolNum: "",
        transToolCustomerName: "",
      },
      modifyForm: {
        transToolCustomerName: "",
        fixedAmount: "",
        fixedQrcodeDescription: "",
        transToolNum: "",
        merchantId: "",
      },
      modifyNameForm: {
        transToolCustomerName: "",
        merchantId: "",
        transToolNum: "",
        qrcodeType: "",
      },
      modifyFormRules: {
        transToolCustomerName: [
          { required: true, message: "请输入码牌名称", trigger: "blur" },
          {
            min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '名称不支持特殊字符和空格', trigger: 'blur',
          },
        ],
      },
      modifyNameFormRules: {
        transToolCustomerName: [
          { required: true, message: "请输入码牌名称", trigger: "blur" },
          {
            min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '名称不支持特殊字符和空格', trigger: 'blur',
          },
        ],
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      code: {
        fixedAmount: 0,
        fixedQrcodeDescription: "",
      },
      loadingTable: false,
      coedDialog: false,
      modifyDeviceDialog: false,
      codeLoading: false,
      tableData: [],
      // 二维码配置
      config: {
        value: "",
        logoSrc: require("../../assets/images/device-manege/logo.png"), // 中间logo的地址
      },
      isZfbBox: false,
      shopType: 1,
      iconArr: [
        require('../../assets/images/device-manege/wx.png'),
        require('../../assets/images/device-manege/zfb.png'),
        require('../../assets/images/device-manege/ysf.png'),
      ],
    };
  },
  computed: {
    activeCode() {
      return [1, 2].includes(this.activeTab);
    },
    activeAndIsZfbBox() {
      return this.activeTab === 2 && this.isZfbBox;
    },
    activeAndNotZfbBox() {
      return this.activeTab === 2 && !this.isZfbBox;
    },
  },
  watch: {
    activeTab() {
      this.queryData();
      this.searchForm.transToolNum = "";
      this.searchForm.transToolCustomerName = "";
    },
  },
  created() {
    this.queryShopList();
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      this.shopType = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).shopType;
    }
  },
  methods: {
    // 获取门店列表
    queryShopList() {
      const { pageNo, finished, pageSize } = this.shopPageInfo;
      if (finished) return false;
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo,
        pageSize,
      };
      this.shopPageInfo.loading = true;
      return queryShopList(params).then((res) => {
        this.shopPageInfo.loading = false;
        if (res.data.error_code === 0) {
          const newList = res.data.data.list;
          this.shopList = [...this.shopList, ...newList];
          if (pageNo === 1) {
            this.searchForm.merchantIdList = [this.shopList[0].merchantId];
            this.queryData();
          }
          if (newList.length < pageSize) {
            this.shopPageInfo.finished = true;
          } else {
            this.shopPageInfo.pageNo += 1;
          }
        }
      });
    },
    // 收款码和云喇叭修改
    modifyDetail(row) {
      this.modifyDeviceDialog = true;
      this.$nextTick(() => {
        this.modifyForm.transToolCustomerName = row.transToolCustomerName;
        this.modifyForm.fixedQrcodeDescription = row.fixedQrcodeDescription;
        this.modifyForm.fixedAmount = row.fixedAmount ? row.fixedAmount / 100 : "";
        this.modifyForm.transToolNum = row.transToolNum;
        this.modifyForm.merchantId = row.merchantId;
        this.modifyNameForm.transToolCustomerName = row.transToolCustomerName;
        this.modifyNameForm.merchantId = row.merchantId;
        this.modifyNameForm.transToolNum = row.transToolNum;
        this.modifyNameForm.qrcodeType = row.qrcodeType ? row.qrcodeType : "";
        this.isZfbBox = row.qrcodeType === 10;
      });
    },
    submitInfo() {
      this.$refs.modifyForm.validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.modifyForm));
          for (const k in params) {
            if (params[k] === '') delete params[k];
          }
          params.toolType = this.activeTab;
          if (params.fixedAmount) params.fixedAmount *= 100;
          this.submitModifyAip(params);
        }
      });
    },
    submitInfoName() {
      this.$refs.modifyNameForm.validate((valid) => {
        if (valid) {
          const params = Object.assign(this.modifyNameForm, { toolType: this.activeTab });
          this.submitModifyAip(params);
        }
      });
    },
    submitModifyAip(params) {
      updateTransToolInfo(params).then((res) => {
        if (res.data.error_code === 0) {
          this.$message.success("操作成功");
          this.queryData();
          this.modifyDeviceDialog = false;
        }
      });
    },
    cancelDevice() {
      this.$nextTick(() => {
        this.modifyDeviceDialog = false;
        this.modifyForm = Object.assign({ transToolCustomerName: "", fixedQrcodeDescription: "", fixedAmount: "" });
        this.modifyNameForm = Object.assign({ transToolCustomerName: "" });
        if (this.$refs.modifyForm !== undefined) {
          this.$refs.modifyForm.resetFields();
        } else if (this.$refs.modifyNameForm !== undefined) {
          this.$refs.modifyNameForm.resetFields();
        }
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryData();
    },
    search() {
      this.page.pageNo = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        toolType: this.activeTab,
        ...this.searchForm,
        ...this.page,
      };
      if (params.merchantIdList.length === 0) {
        this.$message.error("请选择至少1个以上的门店");
        return;
      }
      // 如果是全部门店，需要遍历获取所有的门店id
      if (this.searchForm.merchantIdList[0] === "@") {
        params.merchantIdList = [];
        this.shopList.forEach((v) => {
          if (v.merchantId !== "@") params.merchantIdList.push(v.merchantId);
        });
      }
      this.loadingTable = true;
      listTransToolInfo(params).then((res) => {
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          this.page.count = res.data.data.totalCount;
        }
        // 让用户可以更好的感受tab切换效果
        setTimeout(() => {
          this.loadingTable = false;
        }, 100);
      });
    },
    viewCodeDetail(row) {
      this.coedDialog = true;
      this.code = row;
      const params = {
        merchantId: row.merchantId,
        qrcodeNum: row.transToolNum,
      };
      this.codeLoading = true;
      getQrcodePage(params).then((res) => {
        this.codeLoading = false;
        if (res.data.error_code === 0) {
          this.config.value = res.data.data.qrcodeUrl;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.device-con {
  .tabs {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 50px;
    background-color: #fff;
    border-bottom: 1px solid #f2f3f3;

    .item {
      height: 80px;
      margin-right: 60px;
      font-size: 18px;
      line-height: 80px;
      color: #333;
      cursor: pointer;

      &.active {
        border-bottom: 2px solid #008cff;
      }
    }
  }

  .search {
    .label {
      width: 80px;
      font-size: 14px;
    }

    padding: 40px 50px 20px;

    .el-row {
      margin-bottom: 15px;
    }

    .el-col {
      .label {
        height: 38px;
        line-height: 38px;
      }
    }

    .el-form--inline .el-form-item__label {
      min-width: 83px;
      font-size: 14px;
      font-weight: 400;
      color: #333;

      .el-form-item__content {
        overflow: hidden;
      }
    }

    .btn-base {
      float: right;
      width: 90px;
      height: 32px;
      line-height: 0;
    }
  }

  .table-list {
    overflow: hidden;
    background: #f7f7f7;

    .table-container {
      padding: 40px 50px;
      overflow: hidden;
      background: #fff;
      border-top: 20px solid #eee;

      .table-btn {
        margin-right: 20px;
        color: #1395ff;
        cursor: pointer;
      }

      .last-btn {
        margin-right: 0;
        color: #ffa11b !important;
      }
    }
  }

  .code {
    text-align: center;

    .text {
      margin-bottom: 25px;
    }

    .money {
      font-size: 30px;
      font-weight: bold;

      span {
        font-size: 14px;
      }
    }

    .name {
      font-size: 18px;
    }

    .icon-box {
      display: flex;
      justify-content: space-between;
      width: 160px;
      margin: 20px auto 0;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .code-img {
    text-align: center;
  }

  .modify-device-dialog {
    .el-form-item__label {
      font-weight: normal;
      color: #333;
      text-align: left;
    }

    .el-dialog__header {
      padding: 40px 0 0 40px;
      font-size: 22px;
      font-weight: bold;
      color: #000;
    }

    .el-dialog__body {
      padding: 50px 40px;
    }

    .el-dialog__footer {
      padding: 0 40px 40px;
    }

    .desc {
      display: block;
      margin-left: 120px;
      font-size: 12px;
      line-height: 18px;
      color: #ccc;
    }
  }
}
</style>
